import { Navigate, useLocation, type Location } from "react-router";
import type { ReactNode } from "react";
import { useAuth } from "../lib/auth-context.js";
import { LoadingScreen } from "./loading-screen.js";

/**
 * Wraps a route that requires an authenticated session. Three branches:
 *   loading  — render skeleton with aria-busy.
 *   unauth   — redirect to /signin, preserving the attempted URL in
 *              location.state.from so SignInForm can navigate back
 *              after successful auth.
 *   auth     — render children.
 */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") return <LoadingScreen label="Checking session…" />;
  if (status === "unauth") {
    return (
      <Navigate
        to="/signin"
        replace
        state={{ from: location } satisfies { from: Location }}
      />
    );
  }
  return <>{children}</>;
}
